const windowsKeys = {
  duplicateRow: 'Ctrl+D',
  lockRow: 'Ctrl+L',
  convertTitleRowItemRow: 'Ctrl+;',
  addTitleRowAbove: 'Shift+Alt+↑',
  addRowBelow: 'Ctrl+Shift+↓',
  copyRow: 'Ctrl+Shift+C',
  pasteRow: 'Ctrl+Shift+V',
  cutRow: 'Ctrl+Shift+X',
  trackRow: 'Alt+T',
  globalHighlight: 'Ctrl+Shift+G',
  personalHighlight: 'Ctrl+Shift+H',
  deleteRow: 'Ctrl+Shift+Backspace',
  hideColumn: 'Ctrl+E',
  showAllColumns: 'Ctrl+Shift+E',
  moveColumnLeft: 'Ctrl+←',
  moveColumnRight: 'Ctrl+→',
  widthShrink: 'Ctrl+Shift+←',
  widthGrow: 'Ctrl+Shift+→',

  saveAsNewGE: 'Shift+Alt+S',
  saveGEVersion: 'Alt+S',
  publishGEEverywhere: 'Shift+Ctrl+S',
  openGEInsertModal: 'Alt+G',
  retrieveLatestGE: 'Alt+R',
};

const macKeys = {
  duplicateRow: '⌘D',
  lockRow: '⌘L',
  convertTitleRowItemRow: '⌘;',
  addTitleRowAbove: '⌘⌥↑',
  addRowBelow: '⇧⌘↓',
  copyRow: '⇧⌘C',
  pasteRow: '⇧⌘V',
  cutRow: '⇧⌘X',
  trackRow: '⌥T',
  globalHighlight: '⇧⌘G',
  personalHighlight: '⇧⌘H',
  deleteRow: '⇧⌘⌫',
  hideColumn: '⌘E',
  showAllColumns: '⇧⌘E',
  moveColumnLeft: '⌘←',
  moveColumnRight: '⌘→',
  widthShrink: '⇧⌘←',
  widthGrow: '⇧⌘→',

  saveAsNewGE: '⇧⌥S',
  saveGEVersion: '⌥S',
  publishGEEverywhere: '⇧⌘S',
  openGEInsertModal: '⌥G',
  retrieveLatestGE: '⌥R',
};

export default {
  windowsKeys,
  macKeys,
};
